import React, { useEffect, useState } from 'react';
import introLogo from '../assets/Wild Elephant Logo.jpg';
import scrolledLogo from '../assets/wild-elephant-logo-cropped.png';
import './Navbar.css';

const links = [
  { label: 'Our Story', href: '#story' },
  { label: 'Menu', page: 'menu' },
  { label: 'Brews', href: '#brews' },
  { label: 'Kitchen', href: '#kitchen' },
  { label: 'Experience', href: '#experience' },
  { label: 'Events', href: '#events' },
];

export default function Navbar({ currentPage = 'home', onNavigate }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const compact = scrolled || currentPage !== 'home';

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handler);
    handler();
    return () => window.removeEventListener('scroll', handler);
  }, []);

  const handleScroll = (href) => {
    setMobileOpen(false);
    if (onNavigate) {
      onNavigate('home', href);
      return;
    }

    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  const handlePage = (page) => {
    setMobileOpen(false);
    if (onNavigate) {
      onNavigate(page);
    }
  };

  return (
    <>
      <nav className={`site-nav ${compact ? 'site-nav--scrolled' : ''}`}>
        <a
          href="#hero"
          className="site-nav__brand"
          onClick={(e) => {
            e.preventDefault();
            if (onNavigate) {
              onNavigate('home');
            } else {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }}
        >
          <span className={`site-nav__logo-shell ${compact ? 'site-nav__logo-shell--scrolled' : ''}`}>
            <img
              className="site-nav__logo site-nav__logo--intro"
              src={introLogo}
              alt="Wild Elephant Craft Bar & Kitchen"
            />
            <img
              className="site-nav__logo site-nav__logo--scrolled"
              src={scrolledLogo}
              alt=""
              aria-hidden="true"
            />
          </span>
          <div className="site-nav__brand-text logo-text-desktop">
            <span className="site-nav__brand-main">WILD ELEPHANT</span>
            <span className="site-nav__brand-sub">Craft Bar & Kitchen</span>
          </div>
        </a>

        <ul className="site-nav__links nav-links-desktop">
          {links.map((link) => (
            <li key={link.label}>
              <a
                className={`site-nav__link ${currentPage === link.page ? 'site-nav__link--active' : ''}`}
                href={link.href || '#menu'}
                onClick={(e) => {
                  e.preventDefault();
                  if (link.page) {
                    handlePage(link.page);
                  } else {
                    handleScroll(link.href);
                  }
                }}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="site-nav__actions">
          <button
            className="site-nav__reserve reserve-btn-desktop"
            onClick={() => handleScroll('#reserve')}
          >
            Reserve
          </button>
          <button
            className="site-nav__hamburger hamburger-btn"
            onClick={() => setMobileOpen(true)}
            aria-label="Open menu"
          >
            <span />
            <span />
            <span className="site-nav__hamburger-short" />
          </button>
        </div>
      </nav>

      <div
        className={`mobile-menu__overlay ${mobileOpen ? 'mobile-menu__overlay--open' : ''}`}
        onClick={() => setMobileOpen(false)}
      />
      <div className={`mobile-menu ${mobileOpen ? 'mobile-menu--open' : ''}`}>
        <button className="mobile-menu__close" onClick={() => setMobileOpen(false)}>
          x
        </button>
        {links.map((link) => (
          <a
            key={link.label}
            className="mobile-menu__link"
            href={link.href || '#menu'}
            onClick={(e) => {
              e.preventDefault();
              if (link.page) {
                handlePage(link.page);
              } else {
                handleScroll(link.href);
              }
            }}
          >
            {link.label}
          </a>
        ))}
        <button className="mobile-menu__reserve" onClick={() => handleScroll('#reserve')}>
          Reserve a Table
        </button>
      </div>
    </>
  );
}
